import React from 'react';
import TacticSelectionSection from './TacticSelectionSection';
import { PLAYING_STYLE_OPTIONS } from '../../../constants/coachTactics';

/**
 * PLAYING STYLE. Same props as before; the body and the option list moved out
 * so this section, the offensive one and the defensive one cannot drift apart.
 * The strings below are the originals character for character — they are the
 * keys their rows in translations/components/profile/coach-profile-sections.json
 * are filed under.
 */
const PlayingStyleSection = ({ isEditing, playingStyles = [], onUpdatePlayingStyles }) => (
  <TacticSelectionSection
    isEditing={isEditing}
    values={playingStyles}
    onUpdate={onUpdatePlayingStyles}
    options={PLAYING_STYLE_OPTIONS}
    title="PLAYING STYLE"
    addButtonLabel="+ Add Playing Style"
    emptyLabel="No playing style information available"
    modalTitle="ADD PLAYING STYLE"
    selectLabel="Select Playing Style"
    selectPlaceholder="Select a playing style"
    removeAriaLabel="Remove playing style"
  />
);

export default PlayingStyleSection;
